export const NAME = 'perfectBindingMachines';